import { useSubscription } from "../../../hooks/useSubscription";

const AICoaching = ({ stats, profile, streak }) => {
  const { plan } = useSubscription();

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', padding: '60px 24px', textAlign: 'center',
      background: 'linear-gradient(135deg, #f0f9ff 0%, #faf5ff 100%)',
      borderRadius: 16, border: '1px solid #e0e7ff', minHeight: 320,
    }}>
      <div style={{ fontSize: 56, marginBottom: 20 }}>🤖</div>
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6,
        background: 'linear-gradient(135deg, #4f46e5, #7c3aed)', color: '#fff',
        fontSize: 11, fontWeight: 700, padding: '4px 14px', borderRadius: 20,
        letterSpacing: '0.08em', marginBottom: 16 }}>
        COMING SOON
      </div>
      <h3 style={{ fontSize: 22, fontWeight: 800, color: '#1e1b4b', marginBottom: 12 }}>
        AIコーチング機能
      </h3>
      <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.7, maxWidth: 360, marginBottom: 28 }}>
        あなたの学習データをもとに、AIが個別最適化されたコーチングを提供します。<br />
        現在、鋭意開発中です。もうしばらくお待ちください。
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%', maxWidth: 320 }}>
        {[
          { icon: '📊', text: '学習パターンの深層分析' },
          { icon: '🎯', text: '目標達成への個別ロードマップ' },
          { icon: '💬', text: 'リアルタイム対話型コーチング' },
        ].map(item => (
          <div key={item.text} style={{
            display: 'flex', alignItems: 'center', gap: 12,
            padding: '12px 16px', background: '#fff', borderRadius: 10,
            border: '1px solid #e0e7ff', opacity: 0.7,
          }}>
            <span style={{ fontSize: 20 }}>{item.icon}</span>
            <span style={{ fontSize: 13, color: '#374151', fontWeight: 600 }}>{item.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AICoaching;
